<template>
  <b-modal
    id="lid-modal"
    no-close-on-backdrop
    :ok-title="$t('generals.save')"
    ok-variant="success"
    :cancel-title="$t('generals.cancel')"
    cancel-variant="danger"
    centered
    :title="$t('kanban.add_lead')"
    size="lg"
    @ok="onSubmit"
    @hidden="hideModal"
  >
    <validation-observer ref="infoLid">
      <b-row>
        <b-col md="11">
          <b-form-group
            :label="$t('kanban.client')"
            class="pr-0"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('kanban.client')"
              rules="required"
            >
              <v-select
                v-model="lid.client"
                label="title"
                :reduce="client => client.id"
                :options="clients"
                class="client-select"
                @search="searchClients"
                @open="open('client')"
                @close="onClose('client')"
              >
                <template #list-footer>
                  <li
                    v-show="pagination.client.load"
                    ref="clientLoad"
                    class="loader"
                  >
                    Loading more options...
                  </li>
                </template>
              </v-select>

              <!-- <lazy-loading-select
                :options="getClientsList"
                @fetch="FETCH_CLIENTS_LIST"
              /> -->

              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="1"
          class="d-flex pb-1"
        >
          <!-- <b-form-group class="align-self-end mb-0 mt-75">
            <b-button
              v-b-modal.client-modal
              size="sm"
              variant="success"
              class="p-50 ml-25"
            >
              <feather-icon
                icon="PlusIcon"
                size="22"
              />
            </b-button>
          </b-form-group> -->
        </b-col>

        <b-col md="6">
          <b-form-group
            :label="$t('kanban.select_obj')"
            class="pr-0"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('kanban.select_obj')"
              rules="required"
            >
              <v-select
                v-model="selected_object"
                label="title"
                :reduce="object => object.id"
                :options="GET_OBJECTS"
                @input="objectSelect"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="5">
          <b-form-group
            :label="$t('kanban.select_home')"
            class="pr-0"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('objects.apartment')"
              rules="required"
            >
              <v-select
                v-model="selected_apartment"
                label="title"
                :reduce="product => product.id"
                :disabled="!selected_object"
                :options="GET_APARTMENTS"
                :filterable="false"
                @input="apartmentSelect"
              >
                <template #list-footer>
                  <li
                    v-show="pagination.product.load"
                    ref="productLoad"
                    class="loader"
                  >
                    Loading more options...
                  </li>
                </template>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          md="1"
          class="d-flex pb-1"
        >
          <b-form-group class="align-self-end mb-0 mt-75">
            <b-button
              v-b-modal.flat-selection
              size="sm"
              variant="success"
              class="p-50 ml-25"
            >
              <feather-icon
                icon="GridIcon"
                size="22"
              />
            </b-button>
          </b-form-group>
        </b-col>

        <!-- <b-form-group class="align-self-center mb-0 mt-75 pl-50">
          <b-button
            v-b-modal.modal-add-product-title
            size="sm"
            variant="success"
            class="p-50 ml-25"
          >
            <feather-icon
              icon="PlusIcon"
              size="22"
            />
          </b-button>
        </b-form-group> -->
        <template
          v-for="(product, index) in products"
        >
          <b-col
            v-if="products.length"
            :key="product.id"
            md="11"
          >
            <b-card

              no-body
              bg-variant="primary"
              class="mb-1 text-white p-1"
            >
              <div class="d-flex justify-content-between">
                <span class="border-left pl-50">
                  № {{ product.flat_number }}
                </span>
                <span class="border-left pl-50">
                  {{ product.total_area }} м²
                </span>
                <span class="border-left pl-50">
                  {{ product.rooms_count }}x
                </span>
                <span class="border-left pl-50">
                  {{ $_moneyFormatter(product.total_price) }}
                </span>
              </div>
            </b-card>
          </b-col>

          <b-col
            :key="index"
            md="1"
            class="d-flex pb-1"
          >
            <b-form-group class="align-self-end mb-0 mt-75">
              <b-button
                size="sm"
                variant="danger"
                class="p-50 ml-25"
                @click="deselectFlat(index)"
              >
                <feather-icon
                  icon="XIcon"
                  size="22"
                />
              </b-button>
            </b-form-group>
          </b-col>
        </template>
        <!-- <b-col
          v-if="product"
          md="4"
          class="d-flex align-items-center pb-1"
        >
          <b-button
            v-b-modal.flat-selection
            variant="warning"
          >
            Выбрать квартиру
          </b-button>
        </b-col> -->

        <b-col md="12">
          <b-form-group
            :label="$t('kanban.transaction_amount')"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('kanban.transaction_amount')"
              rules="required"
            >
              <cleave
                v-model="lid.amount"
                class="form-control"
                :raw="true"
                :options="options"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group
            :label="$t('kanban.description')"
          >
            <b-form-textarea
              v-model="lid.description"
              rows="3"
            />
          </b-form-group>
        </b-col>

      </b-row>

    </validation-observer>

    <b-modal
      id="modal-add-product-title"
      size="md"
      :title="$t('kanban.add_product')"
      ok-only
      centered
      ok-variant="warning"
      :ok-title="$t('generals.add')"
    >
      <b-tabs>
        <b-tab title="На Русском">
          <b-card-text>
            <b-form-group
              label="Название"
              class="col-12"
            >
              <b-form-input placeholder="Пример:  Яблоко" />
            </b-form-group>
          </b-card-text>
        </b-tab>
        <b-tab
          active
          title="На Английском"
        >
          <b-card-text>
            <b-form-group
              label="Название"
              class="col-12"
            >
              <b-form-input placeholder="Example:  Apple" />
            </b-form-group>
          </b-card-text>
        </b-tab>
        <b-tab title="На Узбекском">
          <b-card-text>
            <b-form-group
              label="Название"
              class="col-12"
            >
              <b-form-input placeholder="Misol:  Olma" />
            </b-form-group>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-modal>

    <ClientModal />
    <b-modal
      id="flat-selection"
      :ok-title="$t('generals.select')"
      centered
      no-close-on-backdrop
      :cancel-title="$t('generals.cancel')"
      size="xl"
      @ok="selectFlat"
    >
      <vue-selecto
        :data="GET_CHECKERBOARD_LAYOUT"
        :filter="{}"
        :sidebar="true"
        @flatSelected="flat => {
          selected_flat = flat
        }"
      />
    </b-modal>
  </b-modal>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import VSelect from 'vue-select'
import {
  BFormGroup, BFormInput, BCardText, BButton, BModal, BFormTextarea, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import ClientModal from '../../Clients/components/ClientModal.vue'
import formatters from '@/mixins/extra'
import vueSelecto from '@/components/vueSelecto.vue'
// import lazyLoadingSelect from '@/components/lazyLoadingVSelect.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BModal,
    BFormGroup,
    BButton,
    BCardText,
    BFormInput,
    BFormTextarea,
    VSelect,
    Cleave,
    ClientModal,
    BRow,
    BCol,
    BCard,
    vueSelecto,
    // lazyLoadingSelect,
  },
  mixins: [formatters],
  data() {
    return {
      required,
      timeout: 600,
      clients: [],
      pagination: {
        client: {
          load: true,
          page: 0,
          page_size: 15,
          count: 1,
        },
        product: {
          load: true,
          page: 0,
          page_size: 15,
          count: 1,
        },
      },
      lid: {
        client: null,
        product: [],
        amount: null,
        description: '',
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
      },
      clientObserver: null,
      productObserver: null,
      selected_object: null,
      selected_apartment: null,
      selected_flat: null,
      products: [],
    }
  },

  computed: {
    ...mapGetters('clients', ['getClientsList']),
    ...mapGetters('objects', ['GET_OBJECTS']),
    ...mapGetters('apartments', ['GET_CHECKERBOARD_LAYOUT', 'GET_APARTMENTS']),
  },

  mounted() {
    this.FETCH_OBJECTS({ partial: true })
    this.clientObserver = new IntersectionObserver(async ([{ isIntersecting, target }]) => {
      const { page, page_size, count } = this.pagination.client

      if (!isIntersecting) {
        return
      }

      if (count > page * page_size) {
        const res = await this.FETCH_CLIENTS_LIST({ page: page + 1, page_size, partial: true })
        const ul = target.offsetParent
        const { scrollTop } = target.offsetParent
        this.clients = [
          ...this.clients,
          ...res.results,
        ]
        await this.$nextTick()
        ul.scrollTop = scrollTop

        this.pagination.client.count = res.count
        this.pagination.client.page = page + 1
        if (res.count <= 15) {
          this.pagination.client.load = false
        }
      } else {
        this.pagination.client.load = false
      }
    })

    // this.productObserver = new IntersectionObserver(async ([{ isIntersecting }]) => {
    //   const { page, page_size, count } = this.pagination.product

    //   if (!isIntersecting) {
    //     return
    //   }

    //   if (count > page * page_size) {
    //     const res = await this.FETCH_PRODUCTS_LIST({ page: page + 1, page_size })

    //     this.products = [
    //       ...this.products,
    //       ...res.data.results.map(p => ({ title: p.title.ru, id: p.id })),
    //     ]

    //     this.pagination.product.count = res.count
    //     this.pagination.product.page = page + 1

    //     if (res.count <= 15) {
    //       this.pagination.product.load = false
    //     }
    //   } else {
    //     this.pagination.product.load = false
    //   }
    // })
  },

  methods: {
    ...mapActions('clients', ['FETCH_CLIENTS_LIST']),
    ...mapActions('kanban', ['FETCH_PRODUCTS_LIST', 'ADD_NEW_LID']),
    ...mapActions('apartments', ['FETCH_APARTMENT_CHECKERBOARD_LAYOUT', 'FETCH_APARTMENTS_BY_OBJECT']),
    ...mapActions('objects', ['FETCH_OBJECTS']),
    async open(type) {
      await this.$nextTick()
      if (type === 'client') {
        this.clientObserver.observe(this.$refs.clientLoad)
      }
      // this.productObserver.observe(this.$refs.productLoad)
    },
    onClose(type) {
      if (type === 'client') {
        this.clientObserver.disconnect()
      }
      this.productObserver.disconnect()
    },
    onSubmit(bvModalEvt) {
      console.log(this.products)
      bvModalEvt.preventDefault()
      this.$refs.infoLid.validate().then(success => {
        if (success) {
          this.lid.manager = getUserData().id
          this.lid.amount = parseInt(this.lid.amount, 10)
          this.lid.product = this.products.map(el => el.id)

          this.ADD_NEW_LID(this.lid).then(() => {
            console.log('.....')
            this.$emit('saveSuccess')
            this.$nextTick(() => {
              this.$bvModal.hide('lid-modal')
            })
            this.lid = {
              client: [],
              product: [],
              amount: 0,
              description: '',
            }
          })
        }

        // this.lid = {
        //   client: [],
        //   product: [],
        //   amount: null,
        //   description: '',
        // }
      })
    },
    hideModal() {
      this.lid = {
        client: null,
        product: [],
        amount: null,
        description: '',
      }
      this.selected_object = null
      this.selected_apartment = null
      this.products = []
    },
    deselectFlat(index) {
      this.lid.amount = Number(this.lid.amount) - this.products[index].total_price
      // this.lid.amount -= this.products[index].total_price
      this.products.splice(index, 1)
    },
    objectSelect() {
      this.FETCH_APARTMENTS_BY_OBJECT({ id: this.selected_object, partial: true })
    },
    apartmentSelect(id) {
      if (id) {
        this.FETCH_APARTMENT_CHECKERBOARD_LAYOUT(this.selected_apartment).then(() => {
          this.$bvModal.show('flat-selection')
        })
      }
    },
    searchClients(search) {
      if (search) {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.FETCH_CLIENTS_LIST({ search, partial: true, page_size: 15 }).then(resp => {
            this.clients = resp.results
          })
        }, 600)
      }
    },
    selectFlat() {
      this.products.push(this.selected_flat)
      console.log(this.selected_flat.total_price)
      this.lid.amount = Number(this.lid.amount) + this.selected_flat.total_price
    },
  },

}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/libs/vue-select.scss";

.loader {
  text-align: center;
  color: #bbbbbb;
}
</style>
